import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// components
import ContactListHeader from "./contact_list_header";
import ContactListBody from "./contact_list_body";
// store
import { fetchAllDRSafeContacts } from "../../../../store/drSafeContact";
// css
import "./contact_list.css";

const DrSafeContactList = () => {
  const dispatch = useDispatch();

  const [contactList, setContactList] = useState();
  const { drSafeContactList, loading, error } = useSelector(
    (state) => state.drSafeContact
  );

  useEffect(() => {
    console.log("drSafeContactList:", drSafeContactList);
    if (drSafeContactList) {
      setContactList(drSafeContactList);
    }
  }, [drSafeContactList]);

  useEffect(() => {
    dispatch(fetchAllDRSafeContacts());
  }, []);

  return (
    <div className="dr-safe-contact-list-wrapper">
      <ContactListHeader />
      <ContactListBody loading={loading} records={contactList} />
    </div>
  );
};

export default DrSafeContactList;
